import { CheckOutlined } from '@ant-design/icons';
import { locationTypes, period, periodicity, urgency } from '../../../../../../utils/config/widgetsConfig';
import { buildOptionsForSelect } from '../../../../../../utils/hooks/serialization';
import { buildObj } from '../../ConfigurationUtils';

export const thresholdsReturnOptions = (key, configValues, isFetchingCategories, isModalOpen) => {
    switch (key?.toLowerCase()) {
        case 'tenant':
            if (configValues != undefined) {
                var x = configValues?.subTenants?.map(x => { return { label: x, value: x } });
                return x
            }
            else
                return []
        case 'label':
            if (configValues && configValues?.modalConfigs && configValues?.modalConfigs[key]) {
                if (configValues?.modalConfigs[key].result)
                    return uniqueObjectsByProperty(configValues?.modalConfigs[key].result.map(x => { return { label: x.Label, value: x.Label } }), key);
            }
            break;
        case 'periodicity':
            return periodicity.map(x => { return { label: x, value: x } });
        case 'period':
            return period.map(x => { return { label: x, value: x } });
        case 'type':
            return locationTypes.map(x => { return { label: x, value: x } });
        case 'urgency':
            return urgency.map(x => { return { label: x, value: x } });
        case 'incidentservice':
            if (configValues?.[key]?.result)
                return configValues[key].result.map(x => { return { label: x.name, value: x.class } });
            break;
        case 'widgetType':
            return []
        case 'tenantfamilytype':
            return buildOptionsForSelect(configValues);
        default:
            if (configValues && configValues[key]) {
                if (configValues[key].result) {
                    var x = uniqueObjectsByProperty(configValues[key].result.map(x => { return { label: x, value: x } }), key);
                    return x;
                } else if (Array.isArray(configValues[key])) {
                    var x = uniqueObjectsByProperty(configValues[key]);
                    return x;
                }
            }
            else
                return [];
    }
}

const uniqueObjectsByProperty = (array, property) => {
    if (property)
        return Array.from(new Set(array.map(item => item[property]))).map(value => ({ label: value, value: value }));
    else
        return Array.from(new Set(array)).map(value => ({ label: value, value: value }));
}

export const serializeThresholdData = (values) => {
    if (values) {
        return values.result.map((e, index) => {
            return {
                id: e["ID"] + index,
                thresholdId: e["ID"],
                itemName: e["item_name"],
                oldLabel: e["Label"],
                label: e["Label"],
                oldType: e["Type"],
                type: e["Type"],
                oldOpenThreshold: e["Open Threshold"],
                openThreshold: e["Open Threshold"],
                closeThreshold: e["Close Threshold"],
                urgency: e["Urgency"],
                generateIncident: (e["Incident Service"] && e["Category"]) ? <CheckOutlined /> : null,
                incidentService: e["Incident Service"],
                incidentCategory: e["Category"],
                eventDescription: e["Event Description"],
                isDefault: e["Is Default"],
                cityService: e['CityService'],
                tenant: e["tenant"],
            }
        })
    }
}

/**
  * Serializes the selected record for modal.
  *
  * @param {Object} selectedRecord - The selected record object.
  * @param {Object} configValues - The configuration values object.
  * @param {Object} tableRes - The table resources object.
  * @returns {Array} - The serialized record array.
  */
export const serializeRecordForThresholdsModal = (selectedRecord, configValues, tableRes) => {
    const keysToKeep = tableRes.map(x => x.dataIndex);

    return tableRes
        .map(x => {
            const foundObj = Object.entries(selectedRecord).find(([key]) => key === x.dataIndex);
            const value = foundObj ? foundObj : [x.title];
            return buildObj(value, x, null, null, thresholdsReturnOptions, configValues);
        })
        .filter(obj => obj && keysToKeep.includes(obj.key));
};

export const thresholdEmptyRecord = {
    placeholder: null,
    label: null,
    type: null,
    openThreshold: null,
    closeThreshold: null,
    placeholder2: null,
    urgency: null,
    eventDescription: null,
    isDefault: null,
    generateIncident: null,
    incidentService: null,
    incidentCategory: null,
    btn: null,
    Table2: null,
    Table: null,
    id: null,
    Table1: null,
    itemName: null,
    tenant: null,
    cityService: null,
    TenantFamilyType: null,
    selectedItem: null,
    title: null,
    oldLabel: null,
    oldType: null,
    oldOpenThreshold: null,
}